/* eslint-disable @repo/internal/react/no-unsafe-spread-props */
import React from 'react';
import Compiled, { inputCSS as compiledInputCSS } from '../compiled/components/input';
export var inputCSS = function inputCSS(props) {
  return compiledInputCSS();
};
var Input = function Input(props) {
  return /*#__PURE__*/React.createElement(Compiled, props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Input;